export function checkifValueOfArrayIncludesInArray(array, urlRequest) {
    let value = array.map(x => {
        return urlRequest.includes(x)
          })
          return value.some((x) => x == true)
}